function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".mail_sf .a,.mail_sf .b{fill:none;stroke:#fff;stroke-linejoin:round;}.mail_sf .b{stroke-linecap:round;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.5 0.5)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 15.533,
  height: 11.281,
  rx: 3
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.491 5.958)"
}, /*#__PURE__*/React.createElement("line", {
  className: "b",
  x1: 3.509,
  y2: 4.199,
  transform: "translate(0 0)"
}), /*#__PURE__*/React.createElement("line", {
  className: "b",
  x2: 3.509,
  y2: 4.199,
  transform: "translate(11.042 0)"
})), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M182.339,162.054l7.487,5.78,7.425-5.827",
  transform: "translate(-182.037 -160.483)"
}));

var SvgMail = function SvgMail(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "mail_sf",
    width: 16.533,
    height: 12.281,
    viewBox: "0 0 16.533 12.281",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mail.4852e16c.svg";
export { ForwardRef as ReactComponent };